import { Form, Formik } from "formik";
import _ from "lodash";
import { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InitialObjectStructure from "../../FormModel/InitialObjectStructure.json";
import validationSchema from "../../FormModel/validationSchema";
import { WidgetEnum } from "../../Store/WidgetEnum";
import VideoKyc from "../Widgets/VideoKyc/VideoKyc";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import { EntityTypeEnum } from "../../Store/EntityTypeEnum";
import { useSelector } from "react-redux";
import { getApplicationDTO } from "../../Store/WidgetDataSelector";
import { useWidgetService } from "../Widgets/WidgetManager/UseWidgetService";

function VideoKYCForm(props) {
  const { t } = useTranslation("common");
  const [currentValidationSchema, setCurrentValidationSchema] = useState(getFormValidationSchema());
  const applicationContext = useContext(KycApplicationContext);
  const {checkSecondHolderHasVideoKYC} = useWidgetService();
  const applicationDTO = useSelector((state) =>
     getApplicationDTO(state)
  );
  
  // get the form validation schema based on the current widget
  function getFormValidationSchema() {
    var widgetValidationSchema = _.find(
      validationSchema,
      (obj) => obj.widgetShortName === WidgetEnum.VIDEOKYC
    );

    return widgetValidationSchema.validationSchemaObj.fields.videoKycDTO;
  }


  // handle submit
  function _handleSubmit(values, actions) {
    
      props.onSubmit(values).then(
        (res) => {
          // operations to be dont on submit to avoid issues
          actions.setTouched({});
          actions.setSubmitting(false);
        },
        (error) => {
          actions.setSubmitting(false);
        }
      );     
  }

  // tasks to be performed on clicking the back button
  function _handleBack(event,values) {
    event.preventDefault();
    props.onBack(values);       
  }

  //appliction has joint Holder then second holder has video kyc
  function showNext() {
    var showNextButton = false;
    if (
      applicationDTO.kycAccountTypeShortName === "JA" &&
      applicationContext.currentHolder.entityTypeShortName === EntityTypeEnum.FH &&
      checkSecondHolderHasVideoKYC()
    ) {
      showNextButton = true;
    }
    
    return showNextButton;
  }
  
  return (
    <>
      <Formik
        initialValues={props.value || InitialObjectStructure}
        validationSchema={currentValidationSchema}
        onSubmit={_handleSubmit}
        enableReinitialize={true}
      >
        {({ isSubmitting, errors, values, handleChange }) => (
          <Form id="videoKYCForm" autoComplete="off">
           <VideoKyc moveToWidget={props.moveToWidget} moveNextWidgetByName={props.moveNextWidgetByName} />
            {errors && console.log(errors)}
            {/* When ever form data changes then raise on change props with values */}
            {props.onChange(values)} 
            <div className="action_bar d-flex justify-content-between py-2">
              <div>
                {(
                  <Button
                    className="btn shadow-none action_btn"
                    onClick={event=>_handleBack(event,values)}
                  >
                    {" "}
                    {t("form.back")}{" "}
                  </Button>
                )}
              </div>
              {showNext() && <div>
                <Button
                  className="btn shadow-none action_btn me-2"
                  disabled={isSubmitting}
                  type="submit"
                >
                  {" "}
                  {t("form.next")}{" "}
                </Button>              
              </div> }
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default VideoKYCForm;
